function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.0410156 119.551H149.637V121.987C149.637 122.883 148.91 123.61 148.013 123.61H1.66485C0.768035 123.61 0.0410156 122.883 0.0410156 121.987V119.551Z",
  fill: "#DEDEDE"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.40996 109.674C9.71449 109.369 10.1275 109.198 10.5582 109.198H139.12C139.55 109.198 139.963 109.369 140.268 109.674L149.199 118.605C150.222 119.628 149.498 121.377 148.051 121.377H1.62709C0.180411 121.377 -0.544094 119.628 0.478865 118.605L9.40996 109.674Z",
  fill: "#EDEDED"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M9.88477 32.4722C9.88477 31.3512 10.7935 30.4424 11.9146 30.4424H137.762C138.883 30.4424 139.792 31.3512 139.792 32.4722V105.545C139.792 106.666 138.883 107.575 137.762 107.575H11.9146C10.7935 107.575 9.88477 106.666 9.88477 105.545V32.4722Z",
  fill: "#EDEDED"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 15.8389,
  y: 36.0332,
  width: 118.323,
  height: 65.2174,
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 63.9674,
  cy: 66.975,
  rx: 2.46741,
  ry: 2.475,
  fill: "#CBCBCB"
});

var _ref7 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 86.1744,
  cy: 66.975,
  rx: 2.46741,
  ry: 2.475,
  fill: "#CBCBCB"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M76.3043 67.9653C73.4305 67.9653 71.0349 70.0186 70.4959 72.7424C70.3705 73.3763 70.9063 73.9053 71.5525 73.9053L81.0561 73.9053C81.7023 73.9053 82.2381 73.3763 82.1127 72.7424C81.5737 70.0186 79.1781 67.9653 76.3043 67.9653Z",
  fill: "#CBCBCB"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M108 34.5C108 23.7304 116.73 15 127.5 15C138.27 15 147 23.7304 147 34.5C147 45.2696 138.27 54 127.5 54H108V34.5Z",
  fill: "#E75A5A"
});

var _ref10 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M130.177 36.0397C130.118 37.0995 129.241 37.9287 128.18 37.9287L126.821 37.9287C125.759 37.9287 124.883 37.0995 124.824 36.0397L124.189 24.6111C124.125 23.4647 125.038 22.5001 126.186 22.5001L128.815 22.5001C129.963 22.5001 130.875 23.4647 130.811 24.6111L130.177 36.0397Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("rect", {
  x: 130.071,
  y: 46.5,
  width: 5.14286,
  height: 5.14286,
  rx: 2.57143,
  transform: "rotate(180 130.071 46.5)",
  fill: "white"
}));

var _ref11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white",
  transform: "translate(115.5 22.5)"
})));

var SvgWebGenericError = function SvgWebGenericError(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWebGenericError, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/web-generic-error.f73757a1.svg";
export { ForwardRef as ReactComponent };